import Vue from  "vue";
import RegistrationEmbed from './registration-embed';

document.addEventListener("DOMContentLoaded", () => {

  const dismissOverlay = () => {
    window.hasRegistrationOverlay = false;
  };

  [].forEach.call(document.querySelectorAll('[data-embed-form-url]'), (el) => {
    el.addEventListener('click', () => {
      if (window.hasRegistrationOverlay) {
        return;
      }

      window.hasRegistrationOverlay = true;
      const formEl = document.createElement('registration-form-embed');
      document.body.append(formEl);

      new Vue({
        el: formEl,
        components: { RegistrationEmbed },
        data: {url: el.getAttribute('data-embed-form-url')},
        methods: {
          dismiss: dismissOverlay,
        },
        template: '<registration-embed :url="url" @dismiss="dismiss" />'
      });
    });
  });
});
